module.exports = {
      id: "1f623342a2f27abc00f0f5dd8f118868water-none.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#1f623342a2f27abc00f0f5dd8f118868water-none.svg",
      toString: function () {
        return this.url;
      }
    }